import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 42\" id=\"icon-pause\"><rect x=\".5\" y=\".5\" width=\"40.5\" height=\"41\" rx=\"1.5\" fill=\"#fff\" fill-opacity=\".2\" /><rect x=\".5\" y=\".5\" width=\"40.5\" height=\"41\" rx=\"1.5\" stroke=\"#fff\" /><path d=\"M14 15a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H15a1 1 0 0 1-1-1V15Zm11 0a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V15Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol